import { createStyles } from "@mantine/core";
const useStyles = createStyles((theme) => ({
  noteTypeParent: {},
  labelStyle:{
    marginBottom:"8px"
  }
}));

export default useStyles;
